module.exports = __webpack_public_path__ + "static/memoji-item-3-b1d43e96b9cccb3604f8abf0290cbd3e.png";